import { render } from "./InventoryImportExcelView.vue?vue&type=template&id=7ccddbae"
import script from "./InventoryImportExcelView.vue?vue&type=script&lang=js"
export * from "./InventoryImportExcelView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__